function UserPerGroup({ user }) {
  return (
    <>
      <div className='info-container'>
        <p className='user-date'>{user?.dni}</p>
        <p className='user-date-name'>{user?.name}</p>
      </div>
    </>
  );
}

export default UserPerGroup;
